import { ConsultarHomologacaoOcupante } from "./ConsultarHomologacao";

export default ConsultarHomologacaoOcupante;